import { ArrowDownRight, MessageCircle, AlertTriangle, BellRing } from "lucide-react";

export default function WhatsAppShowcase() {
  return (
    <section
      data-testid="whatsapp-showcase"
      className="relative py-16 sm:py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative max-w-md mx-auto">
            <div className="absolute -inset-6 bg-gradient-to-br from-blue-500/20 to-transparent blur-3xl rounded-3xl" />
            <div className="relative glass-card rounded-3xl p-1.5">
              <div className="rounded-[1.25rem] bg-slate-950/70 p-5 border border-white/[0.04] space-y-3">
                <div className="flex items-center gap-3 pb-3 border-b border-white/[0.06]">
                  <div className="h-9 w-9 rounded-full bg-amber-500/20 border border-amber-500/30 flex items-center justify-center">
                    <AlertTriangle className="h-4 w-4 text-amber-300" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-white">Cliente: Sofia R.</div>
                    <div className="text-[11px] text-amber-300">IA pausada · aguarda humano</div>
                  </div>
                </div>

                <div className="flex">
                  <div className="max-w-[85%] rounded-2xl rounded-tl-md px-4 py-2.5 bg-white/[0.04] border border-white/[0.06] text-slate-200 text-sm">
                    Tenho pele sensível com rosácea. Fazem peeling químico na mesma?
                  </div>
                </div>

                <div className="rounded-xl bg-amber-500/[0.06] border border-amber-500/20 p-3 text-xs text-amber-200/90 flex items-start gap-2">
                  <BellRing className="h-4 w-4 mt-0.5 flex-none" />
                  <div>
                    <div className="font-medium text-amber-200">A IA não tem a certeza.</div>
                    <div className="mt-1 text-amber-200/70">
                      IA pausada por 4h. Notificação enviada para o seu número pessoal.
                    </div>
                  </div>
                </div>

                <div className="flex justify-end">
                  <div className="max-w-[85%] rounded-2xl rounded-tr-md px-4 py-2.5 bg-emerald-600/20 border border-emerald-500/30 text-slate-100 text-sm">
                    <span className="text-emerald-300 text-[11px] font-medium block mb-1">RESPOSTA DA EQUIPA</span>
                    Olá Sofia! Com rosácea não recomendamos peeling. Temos limpeza suave para pele sensível. Posso marcar uma consulta?
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full glass-card text-[11px] font-semibold uppercase tracking-[0.2em] text-amber-300">
            <MessageCircle className="h-3.5 w-3.5" />
            Painel de Conversas
          </div>
          <h2 className="mt-6 text-3xl sm:text-4xl md:text-5xl lg:text-[3.5rem] tracking-tighter text-white leading-[1.05]">
            Só entra na conversa<br />
            <span className="text-gradient-blue">quando é mesmo preciso.</span>
          </h2>
          <p className="mt-6 text-lg text-slate-400 leading-relaxed max-w-xl font-light">
            Cada conversa tem um estado claro. Quando responder manualmente, o flag de
            "aguarda humano" limpa-se sozinho. Notas internas ficam visíveis só para a
            sua equipa, e a IA também as alimenta com o que aprende sobre o cliente.
          </p>

          <ul className="mt-10 space-y-4">
            {[
              "Histórico completo da conversa, com contexto de marcações",
              "Notas privadas alimentadas pela IA (preferências, alergias, etc.)",
              "Notificação no seu WhatsApp pessoal a cada escalamento",
              "A IA retoma sozinha após o tempo combinado; definimos isso consigo",
            ].map((t) => (
              <li key={t} className="flex items-start gap-3 text-slate-300">
                <ArrowDownRight className="h-5 w-5 text-blue-400 mt-0.5 flex-none" />
                <span>{t}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
